import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import MultiSelect from '../MultiSelect';
import { seniorityOptions } from '../../organisms/contactsFilters/defaultFilters';

const SeniorityMultiSelect = ({ name, value, title, setFilters }) => {
  const selectedSeniorities = useMemo(
    () => seniorityOptions.filter((options) => value?.some((selected) => selected.value === options.value)),
    [value],
  );

  return (
    <MultiSelect
      title={title}
      options={seniorityOptions}
      selected={selectedSeniorities}
      onSelect={(values) => setFilters({ [name]: values })}
      showSearch={false}
      dropdownSx={{ maxHeight: '300px' }}
    />
  );
};

SeniorityMultiSelect.propTypes = {
  name: PropTypes.string,
  value: PropTypes.array,
  title: PropTypes.string,
  setFilters: PropTypes.func.isRequired,
};

SeniorityMultiSelect.defaultProps = {
  name: 'workExperiencesSeniority',
  value: [],
  title: 'Seniority',
};

export default SeniorityMultiSelect;
